import React from "react";

const ContentHeadCapsul = ({ children }) => {
  return (
    <div className="bg-tea-green d-inline-block px-3 py-2 rounded-5 fw-500 text-phthalo-green fs-14 mb-4">
      {children}
    </div>
  );
};

export default ContentHeadCapsul;
